























































import Vue from 'vue'
import hljs from 'highlight.js'
import marked from 'marked'
import { createComponent, reactive, watch, computed, toRefs, onMounted } from '@vue/composition-api'
import Box from './box.vue'
import { User } from '../types/comment'

const getQuotaReg = function (str: string) {
  return new RegExp(`> ${str}\n`, 'g')
}
const handleInput = function (e: any) {
  e.target.style.height = 'auto'
  const height = e.target.scrollHeight
  e.target.style.height = `${height}px`
}

export default createComponent<{ quoteInput: string, user: User }>({
  components: {
    Box
  },

  setup (props, context) {
    const state = reactive({
      tab: 0,
      input: '',
      inputCompiler: '',
      oldInput: ''
    })
    const btnDisabled = computed(() => {
      return !state.input.length || !props.user
    })
    const compiler = function () {
      state.inputCompiler = marked(state.input, {
        sanitize: true,
        smartlists: true,
        smartypants: true,
        highlight (code: string) {
          return hljs.highlightAuto(code).value
        }
      })
    }
    const handleTab = function (tab: 0 | 1) {
      if (tab === 1) {
        compiler()
        Vue.nextTick(() => {
          state.tab = tab
        })
      } else {
        state.tab = tab
      }
    }
    const handleSubmit = function () {
      if (!btnDisabled.value) {
        compiler()
        context.emit('submit', state.input, state.inputCompiler)
      }
    }

    onMounted(() => {
      watch(() => props.quoteInput, (val: string) => {
        if (val) {
          state.input = `> ${val}\n${state.oldInput
            ? state.input.replace(getQuotaReg(state.oldInput), '')
            : state.input
          }`
          state.oldInput = val
          Vue.nextTick(() => {
            context.emit('update:quote-input', '')
            // @ts-ignore
            context.refs.textarea.focus()
          })
        }
      })
    })
    return {
      handleTab,
      handleSubmit,
      ...toRefs(state),
      btnDisabled,
      handleLogin () {
        context.emit('login')
      },
      handleInput,
      resetEditor () {
        state.tab = 0
        state.input = ''
        state.inputCompiler = ''
        state.oldInput = ''
      }
    }
  },

  props: {
    quoteInput: {
      type: String,
      default: ''
    },
    user: {
      type: Object
    }
  }
})
